import { ICON__check, ICON__plus } from '@/assets/icons_fa';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { DTO__ml_asset_lora_tag_frequency } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset_lora_tag_frequency';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';
import { useMemo } from 'react';

interface PROPS {
  field: FIELD__list_token;
  tag: DTO__ml_asset_lora_tag_frequency;
  hash_sha256: string;
}

export function G_UI_FIELD__token_list_add_lora_tag_block_item({ field, tag, hash_sha256 }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);

  const is_added = useMemo(() => field.items.some(item => item.word_english.get_value() == tag.word), [field, tag]);

  async function onClick(e: React.MouseEvent) {
    if (is_added) return;

    e.stopPropagation();

    let field_new = field.clone();
    let field_token = field_new.create_item_new(true);
    field_token.type = ENUM__token_type.WORD;

    field_token.word_english.set_value(tag.word);

    field_new.field_name_and_path__fill_for_children();

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  if (generation_current.is_stub()) return null;

  return (
    <div
      {...{ onClick }}
      className={`flex flex-row items-center gap-1  p-1 text-component-item-foreground bg-component
    ${!is_added && 'cursor-pointer'}
    `}
      key={`${field.meta.field_id}_${hash_sha256}_${tag.word}`}
    >
      {is_added && <ICON__check className="size-3" />}
      {!is_added && <ICON__plus className="size-3" />}
      {tag.word} {tag.frequency_percent}%
    </div>
  );
}
